const ShortLogoIcon = () => {
    return <svg width="16" height="17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M3.39 16.391H.686L7.269.438h2.8L3.39 16.391z" fill="#31AF85"></path>
        <path d="M10.069 3.441L8.692 6.835l3.91 9.603h2.847L10.07 3.441z" fill="#3D3935">
        </path>
    </svg>

}

export default ShortLogoIcon;